import { useEffect, useState, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import { fetchCurrentProfile } from "@/services/auth";

/**
 * Protege las rutas /app/admin/* — además de requerir sesión (eso ya lo
 * hace RequireAuth, que envuelve a este componente), exige que el perfil
 * tenga role = "admin". Si no es admin, lo regresa al Dashboard en vez de
 * dejarlo ver el panel.
 */
export default function RequireAdmin({ children }: { children: ReactNode }) {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);
  const [isAdmin, setIsAdmin] = useState(false);

  useEffect(() => {
    let active = true;

    fetchCurrentProfile().then((profile) => {
      if (!active) return;
      if (profile?.role === "admin") {
        setIsAdmin(true);
        setChecking(false);
      } else {
        navigate("/app/dashboard", { replace: true });
      }
    });

    return () => {
      active = false;
    };
  }, [navigate]);

  if (checking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <i className="ri-loader-4-line animate-spin text-3xl text-primary-500"></i>
      </div>
    );
  }

  if (!isAdmin) return null;

  return <>{children}</>;
}
